export default __webpack_public_path__ + "static/media/post-11-detail.70f347d4.jpg";